<template>
  <div>
    <!-- Datatable hidden while data is loading -->
    <div v-if="!loading">
    <v-toolbar elevation="0">
      <v-toolbar-title class="primary--text"><h2>Waste Types</h2></v-toolbar-title>
      <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search ..."
        single-line
        hide-details
      >
      </v-text-field>
    </v-toolbar>
      <!-- Datatable -->
      <v-data-table
          :headers="headers"
          :items="wasteTypeData"
          :search="search"
          class="elevation-1">
        <!-- Row action (edit/delete) -->
        <template v-slot:item.actions="{ item }">
          <v-icon
              small
              class="mr-2"
              @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon
              small
              @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>

      <br/>

      <!-- Load More button -->
      <!--<v-btn v-on:click="loadMore">More</v-btn>-->

      <!-- Driver Dialog (create/edit) -->
      <v-dialog
          v-model="dialog"
          max-width="500px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="primary"
              dark
              class="mt-1,5 ml-2"
              v-bind="attrs"
              v-on="on"
          >
            New Item
          </v-btn>
        </template>
        <CreateDialog
            v-bind:close-function="closeDialog"
            v-bind:form-title="dialogTitle"
            v-bind:item="editWaste"
            v-bind:save-function="saveWaste" />
      </v-dialog>

      <!-- Delete confirmation dialog -->
      <v-dialog v-model="deleteDialog" max-width="500px">
        <DeleteDialog
          v-bind:close-delete="closeDialog"
          v-bind:delete-item-confirm="deleteWaste">
          </DeleteDialog>
      </v-dialog>
    </div>

    <!-- Display loader when fetching data -->
    <div v-if="loading">
      <Loading/>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading';
import CreateDialog from "@/components/waste-type/CreateDialog";
import DeleteDialog from "@/components/waste-type/DeleteDialog";
import { doc, getFirestore, addDoc, collection, getDocs, deleteDoc, limit, startAfter, updateDoc }from "firebase/firestore";
const db = getFirestore();

async function cleanupAfterDialog(context) {
  context.editWaste = {};
  context.query = null;
  context.wasteTypeData = [];
  await context.loadMore();
  context.closeDialog();
}

export default {

  name: 'wasteType',
  components: {DeleteDialog, CreateDialog, Loading },

  data() {
    return {
      dialog: false,
      dialogTitle: 'New Waste Type',
      deleteDialog: false,
      editWaste: {},
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Key', value: 'key' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      wasteTypeData: [],
      options: {
        page: 1,
        pageSize: 10
      },
      loading: false,
      query: null,
      lastVisible: null,
      search: ''
    }
},

methods: {
    closeDialog() {
      this.dialog = false;
      this.deleteDialog = false;
      this.dialogTitle = 'New Waste Type';

      this.$nextTick(() => {
        Object.assign(this.editWaste, {});
      })
    },

    async saveWaste() {
      if (!this.editWaste.id) {
        addDoc(collection(db, 'waste-types'), this.editWaste)
        .then( async () => {
          await cleanupAfterDialog(this);
        });
      } 
      else {
        updateDoc(doc(db, 'waste-types', this.editWaste.id), this.editWaste, { merge: true })
        .then( async () => {
          await cleanupAfterDialog(this);
        });
      }
      this.dialog = false;
    },
    async deleteWaste() {
      deleteDoc(doc(db, 'waste-types', this.editWaste.id))
      .then( async () => {
        await cleanupAfterDialog(this);
      });
    },
    async editItem(wasteType) {
      Object.assign(this.editWaste, wasteType);
      this.dialogTitle = "Edit Waste Type";
      this.dialog = true;
    },
    async deleteItem(wasteType) {
      Object.assign(this.editWaste, wasteType);
      this.deleteDialog = true;
    },
    mapData(wasteType, wasteTypeId) {
      return {
        id: wasteTypeId,
        name: wasteType.name,
        key: wasteType.key,
      }
    },

    async getNextData(options) {
      this.loading = true;
      this.options = options;
      const { pageSize } = options;
      if (!this.query) {
        this.query = getDocs(collection(db, 'waste-types'), limit(pageSize));
      }
      const currentQuery = this.query;
      currentQuery
          .then((snapshot) => {
            this.lastVisible = snapshot.docs[snapshot.docs.length - 1];
            if (!this.wasteTypeData) {
              this.wasteTypeData = [];
            }
            snapshot.forEach((res) => {
              this.wasteTypeData.push(this.mapData(res.data(), res.id));
            });
            this.query = getDocs(collection(db, 'waste-types'), startAfter(this.lastVisible), limit(pageSize));
            this.loading = false;
          })
          .catch(e => {
            console.log(e);
            this.loading = false;
          });
    },

    async loadMore() {
      await this.getNextData(this.options);
    }
  },
  async mounted() {
    if (this.wasteTypeData.length === 0) {
      await this.getNextData(this.options);
    }
  }
}

</script>

<style scoped>

</style>